import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { count, openCart } = useCart();

  const menuItems = [
    { name: "About Us", path: "/aboutus" },
    { name: "Gallery", path: "/gallery" },
    { name: "Lessons", path: "/lessons" },
    { name: "Contact", path: "/contact" }
  ];

  return (
    <nav className="fixed w-full bg-linen-50/90 backdrop-blur-xs z-50 shadow-xs border-b border-linen-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="font-display text-2xl font-semibold text-walnut-800">
            Tree to Table
          </Link>

          <div className="flex items-center gap-4">
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="text-walnut-600 hover:text-copper-600 transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>

            {/* Cart Button */}
            <button
              onClick={openCart}
              className="relative flex items-center gap-2 bg-linen-100 hover:bg-linen-200 rounded-full px-4 py-2 text-walnut-700 text-sm font-medium"
            >
              Cart
              {count > 0 && (
                <span className="bg-copper-500 text-linen-50 text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                  {count}
                </span>
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'} bg-linen-50 border-t border-linen-200`}>
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="block px-4 py-2 text-walnut-600 hover:bg-linen-100"
              onClick={() => setIsMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;